 import {
     ESTAGIO_PROSPECCAO,
     ESTAGIO_CHAMADA_TELEFONICA,
     ESTAGIO_PRIMEIRA_VISITA,
     ESTAGIO_EFETIVADO,
     ESTAGIO_NEGATIVADO,
     ESTAGIO_SEGUNDA_VISITA,
     ESTAGIO_EM_ESPERA,
     ESTAGIO_NEGOCIACAO,
     ESTAGIO_PERDIDO,
 } from '@/constants/pedidoEstagio.js';

const upper = (text) => text.replace(/^\w/, c => c.toUpperCase());
export default {
  upper(text){
    return upper(text);
  },
  getStatusName(status){
    const statusName = status.toLowerCase();
    switch (statusName) {
        case 'lost':
          return 'Perdido';
        case 'cold':
          return 'Em espera';

        default:
          return statusName;
      }
      return statusName;
  },
getNameEstagio(estagio){
    switch (estagio) {
         case ESTAGIO_PROSPECCAO:
             return 'Prospecção';

         case ESTAGIO_CHAMADA_TELEFONICA:
             return 'Chamada Telefônica';

         case ESTAGIO_PRIMEIRA_VISITA:
             return 'PrimeiraVisita';

         case ESTAGIO_NEGOCIACAO:
             return 'Negociação';

         case ESTAGIO_EFETIVADO:
             return 'Efetivado';

         case ESTAGIO_NEGATIVADO:
             return 'Em Processo de Análise';

         case ESTAGIO_PERDIDO:
             return 'Perdido';

         case ESTAGIO_EM_ESPERA:
             return 'Em Espera';

         case ESTAGIO_SEGUNDA_VISITA:
             return 'Segunda Visita';
    }
    return '';
},
  getCoresEsteira(estagio){
    switch (estagio) {

    case ESTAGIO_PROSPECCAO:
    return 'blue-aqua-light';

     case ESTAGIO_CHAMADA_TELEFONICA:
     return 'pink-light';

     case ESTAGIO_PRIMEIRA_VISITA:
     return 'yellow-light';

     case ESTAGIO_NEGOCIACAO:
     return 'blue-light';

     case ESTAGIO_EFETIVADO:
     return 'green-light';

     case ESTAGIO_NEGATIVADO:
     return 'red';

     case ESTAGIO_PERDIDO:
     return 'reddark';

     case ESTAGIO_EM_ESPERA:
     return 'blue darken-4';

     case ESTAGIO_SEGUNDA_VISITA:
         return 'orange-light';
    }
    return '';
  },
  getContatoStatus(id) {
          switch (id) {
              case 1:
                  return 'Efetuado e agendado';
              case 2:
                  return 'Não atendeu';
              case 3:
                  return 'Telefone ocupado';
              case 4:
                  return 'Telefone não existe';
              case 5:
                  return 'Telefone desligado';
              case 6:
                  return 'Efetuado com retorno';
              case 7:
                  return 'Não possui mais interesse';
          }
      },
      getVisitaStatus(id) {
          switch (id) {
              case 1:
                  return 'Marcação';
              case 2:
                  return 'Efetuada com sucesso';
              case 3:
                  return 'Remarcada';
              case 4:
                  return 'Não estava presente';
              case 5:
                  return 'Cancelada';
          }
      },

      getEstagioID(estagio_id){
         switch (estagio_id) {
             case ESTAGIO_PROSPECCAO:
                 return 'Efetuado e agendado';
             case ESTAGIO_CHAMADA_TELEFONICA:
                 return 'Não atendeu';
             case ESTAGIO_PRIMEIRA_VISITA:
                 return 'Telefone ocupado';
             case ESTAGIO_EFETIVADO:
                 return 'Telefone não existe';
             case ESTAGIO_NEGATIVADO:
                 return 'Telefone desligado';
             case ESTAGIO_SEGUNDA_VISITA:
                 return 'Efetuado com retorno';
             case ESTAGIO_EM_ESPERA:
                 return 'Não possui mais interesse';
         }
        },

          getEstagioIDVisita(estagio_id) {
            switch (estagio_id) {
                case ESTAGIO_PROSPECCAO:
                    return 'Marcação';
                case ESTAGIO_CHAMADA_TELEFONICA:
                    return 'Efetuada com sucesso';
                case ESTAGIO_PRIMEIRA_VISITA:
                    return 'Remarcada';
                case ESTAGIO_EFETIVADO:
                    return 'Não estava presente';
                case ESTAGIO_NEGATIVADO:
                    return 'Cancelada';
              }
            return '';
        },

getContatoTipo(estagio) {
    if (estagio.pedido_contato_tipo && estagio.pedido_contato_tipo != '') {
        return upper(estagio.pedido_contato_tipo);
    }
    if (estagio.pedido_visita_tipo && estagio.pedido_visita_tipo != '') {
        return upper(estagio.pedido_visita_tipo);
    }
    if (estagio.pedido_visita_avulsa_tipo && estagio.pedido_visita_avulsa_tipo != '') {
        return upper(estagio.pedido_visita_avulsa_tipo);
    }
    if (estagio.pedido_contato_avulso_tipo && estagio.pedido_contato_avulso_tipo != '') {
        return upper(estagio.pedido_contato_avulso_tipo);
    }
},
getCorEstagio(estagio) {
    switch (estagio) {

        case ESTAGIO_PROSPECCAO:
            return '#34bbd2';

        case ESTAGIO_CHAMADA_TELEFONICA:
            return '#ec3d87';

        case ESTAGIO_PRIMEIRA_VISITA:
            return '#fad11e';

        case ESTAGIO_NEGOCIACAO:
            return '#5090f9';

        case ESTAGIO_EFETIVADO:
            return '#90ce47';

        case ESTAGIO_NEGATIVADO:
            return '#f73c4f';

        case ESTAGIO_PERDIDO:
            return '#F44336';

        case ESTAGIO_EM_ESPERA:
            return '#2047a0';

        case ESTAGIO_SEGUNDA_VISITA:
            return '#f59826';


    }
    return '';
},

 formatLabelChart(str, maxwidth) {
     let sections = [];
     let words = str.split(" ");
     let temp = "";

     words.forEach(function (item, index) {
         if (temp.length > 0) {
             var concat = temp + ' ' + item;

             if (concat.length > maxwidth) {
                 sections.push(temp);
                 temp = "";
             } else {
                 if (index == (words.length - 1)) {
                     sections.push(concat);
                     return;
                 } else {
                     temp = concat;
                     return;
                 }
             }
         }

         if (index == (words.length - 1)) {
             sections.push(item);
             return;
         }

         if (item.length < maxwidth) {
             temp = item;
         } else {
             sections.push(item);
         }

     });

     return sections;
 },

 getDate(value, format = 'DD/MM/YYY'){
    return moment(value).format(format);
 }
}



// WEBPACK FOOTER //
// ./src/helpers/converter.js